import { Box, Button, IconButton, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { icons } from "../../../../utils/icons"
import { useTranslation } from "react-i18next"
import { Item, ObjectGeneric, onChange } from "../../../../utils/types/generals"
import { createRef, useCallback, useEffect, useRef, useState } from "react"
import { SectionType } from "./enums"
import { useContextState } from "../../../../hooks/theme"
import { DaysWeek } from "../../../reportFolio/pages/notifications/pages/main/utils/enums/tabs"
import dayjs from "dayjs"
import { toUnitTimeZone } from "../../../../utils/methods/calcDate"
import { Constants } from "../../../../utils/constants"
import { questionnaire, scheduleServiceFetch, userScheduleServiceFetch, userServiceFetch } from "../../../../utils/constants/callService"
import { DateModalRangeRef } from "../../../../components/dinamicForm/dateModal"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import Loader from "../../../../components/loader"
import SimpleModal from "../../../../components/modal/simpleModal"
import { ScheduleService } from "../../../../service/schedule"
import { httpFetch } from "../../../../utils/crud"
import { RequestErrors, Roles, Types } from "../../../../utils/enums"
import { CustomTable, SnackSimple } from "../../../../components"
import { handleAllErrors } from "../../../../utils/methods/handleErrors"
import { FrequencyEnum, ScheduleEnumType } from "../../../calendar/pages/form/components/steps/configCalendar/enums"
import { daysOfWeek } from "../../../calendar/pages/form/constans/inputs"
import { getQuestionnarie } from "../../../calendar/pages/main/methods"
import { ConfigCalendarSerie } from "../../../calendar/pages/editSerie/components/configCalendarSerie"
import { getUsers, getUserTypes } from "../../../../utils/methods/geServiceWithItemsFormat"
import { RefTable } from "../../../../components/table/types"
import { HeaderTable } from "./components/headerTable"
import { useFilter } from "./hooks/useFilter"
import { getLocalStorage } from "../../../../utils/crud/crypt"
import { useInput } from "./hooks/input"
import { InputModel } from "../../../../utils/types"
import { questionnairesInput, usersInput } from "../detail/constants"
import { formatresponseSchedule } from "./response"
import { formatDataToEndoint } from "./format"
import { eachDayOfInterval } from "date-fns"



const EditSerieUser = () => {

    const styles = useStyles()
    const { t } = useTranslation()
    const [data, setData] = useState<ObjectGeneric>({})
    const refTable = useRef<RefTable>(null)
    const [errors, setErrors] = useState<Record<string, string>>({})
    const [selectedDays, setSelectedDays] = useState<number[]>([DaysWeek.MONDAY, DaysWeek.TUESDAY, DaysWeek.WEDNESDAY, DaysWeek.THURSDAY, DaysWeek.FRIDAY, DaysWeek.SATURDAY, DaysWeek.SUNDAY])
    const location = useLocation();
    const navigate = useNavigate()
    const { id } = useParams()
    const option: ScheduleEnumType = location.state?.option;
    const [section, setSection] = useState(SectionType.IndexSerie)
    const [startDate, setStartDate] = useState<number | undefined>(undefined)
    const [mimTimeZone, setmimTimeZone] = useState(Constants.defaultTimeZoneObject)
    const refRange = createRef<DateModalRangeRef>()
    const { colors } = useContextState()
    const [canChangeStore, setCanChangeStore] = useState(true)
    const [hasInitialized, setHasInitialized] = useState(true);
    const [isLoading, setIsLoading] = useState(false)
    const [loadingLocal, setLoadingLocal] = useState(false)
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [selected, setSelected] = useState<{ users: number[]; questionnaire: number[] }>({ users: [], questionnaire: [] })
    const [selectedText, setSelectedText] = useState<{ users: string; questionnaire: string }>({ users: '', questionnaire: '' })
    const [openSnackbar, setOpenSnackbar] = useState({
        open: false,
        message: '',
        type: Types.SUCCESS,
    })

    const [modal, setModal] = useState<{
        open: boolean
        title: string
        description?: string
        children?: JSX.Element
        removeCancel?: boolean
        confirm: () => void
        isLoading: boolean
    }>({
        open: false,
        title: '',
        confirm: () => { },
        isLoading: false
    })

    const closeModal = () => {
        setModal(prev => ({
            ...prev,
            open: false,
        }))
    }

    const handleCloseSnackbar = (value: boolean) => setOpenSnackbar({ ...openSnackbar, open: value })

    const formatSelectedDays = (selectedDays: number[]): string => {
        const labels = daysOfWeek
            .filter(day => selectedDays.includes(day.value))
            .map(day => day.label);

        if (labels.length === 0) return '';
        if (labels.length === 1) return labels[0];
        if (labels.length === 2) return `${labels[0]} y ${labels[1]}`;

        const allButLast = labels.slice(0, -1).join(', ');
        const last = labels[labels.length - 1];
        return `${allButLast} y ${last}`;
    };

    const assignedChildren = () => {
        let newChilds: string[] = [];
        let description = '';

        if (option == ScheduleEnumType.UNIQUE) {
            description = t('schedule.modal.saveConfiguration');
        }

        if (option == ScheduleEnumType.SERIE) {
            description = t('schedule.modal.areYouSureToEditThisSerie');
        }

        if (option == ScheduleEnumType.RECURRENT) {
            description = t('schedule.modal.areYouSureToEditThisSchedule');
        }

        if (option == ScheduleEnumType.UNIQUE || option == ScheduleEnumType.SERIE) {
            if (!!data.openQuestionnaire) {
                newChilds = [
                    t('schedule.assigned.freeScheduling')
                ];

            } else {
                if (data.frequency == FrequencyEnum.UNIQUE) {
                    const fechaFrom = dayjs(data.from).format(Constants.dayjsFormatDate);
                    const horaFrom = dayjs(data.from).format(Constants.dayjsFormatTime);
                    const parsedHoraFrom = dayjs(horaFrom, 'hh:mm A');
                    const horaFromParse = parsedHoraFrom.hour() % 12 || 12;
                    const isHoraFromOne = horaFromParse === 1;
                    const fechaTo = dayjs(data.to).format(Constants.dayjsFormatDate);
                    const horaTo = dayjs(data.to).format(Constants.dayjsFormatTime);
                    const parsedHoraTo = dayjs(horaTo, 'hh:mm A');
                    const horaToParse = parsedHoraTo.hour() % 12 || 12;
                    const isHoraToOne = horaToParse === 1;
                    newChilds = [
                        t('schedule.assigned.singlSscheduling'),
                        isHoraFromOne && isHoraToOne ?
                            t('schedule.assigned.availablefromOne', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                            :
                            isHoraFromOne && !isHoraToOne ?
                                t('schedule.assigned.availablefromOnlyOne', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                                :
                                !isHoraFromOne && isHoraToOne ?
                                    t('schedule.assigned.availablefromOnlyTwo', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                                    :
                                    t('schedule.assigned.availablefromTow', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                    ];
                }

                if (data.frequency == FrequencyEnum.DAYLI) {
                    const fechaFrom = dayjs(data.fromDateDaily).format(Constants.dayjsFormatDate);
                    const horaFrom = dayjs(data.startDateDaily).format(Constants.dayjsFormatTime);
                    const fechaTo = dayjs(data.toDateDaily).format(Constants.dayjsFormatDate);
                    const horaTo = dayjs(data.endDateDaily).format(Constants.dayjsFormatTime);
                    const days = formatSelectedDays(selectedDays);

                    const parsedHoraFrom = dayjs(horaFrom, 'hh:mm A');
                    const horaFromParse = parsedHoraFrom.hour() % 12 || 12;
                    const isHoraFromOne = horaFromParse === 1;
                    const parsedHoraTo = dayjs(horaTo, 'hh:mm A');
                    const horaToParse = parsedHoraTo.hour() % 12 || 12;
                    const isHoraToOne = horaToParse === 1;
                    newChilds = [
                        t('schedule.assigned.dailyScheduling'),
                        isHoraFromOne && isHoraToOne ?
                            t('schedule.assigned.availableEveryDayFromOne', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                            :
                            isHoraFromOne && !isHoraToOne ?
                                t('schedule.assigned.availableEveryDayFromOnlyOne', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                                :
                                !isHoraFromOne && isHoraToOne ?
                                    t('schedule.assigned.availableEveryDayFromOnlyTwo', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo })
                                    :
                                    t('schedule.assigned.availableEveryDayFromTwo', { startDate: fechaFrom, startHour: horaFrom, endDate: fechaTo, endHour: horaTo }),
                        t('schedule.assigned.generatedEveryEdit', { days: days }),
                        t('schedule.assigned.initialGenerationEdit', { startDate: fechaFrom, endDate: fechaTo })
                    ];
                }

                if (data.frequency == FrequencyEnum.WEEKLY) {
                    const fechaFrom = dayjs(data.fromDateWeekly).format(Constants.dayjsFormatDate);
                    const fechaTo = dayjs(data.toDateWeekly).format(Constants.dayjsFormatDate);
                    const days = formatSelectedDays(selectedDays);
                    const dayNumber = Number(data.duration.replace(/\D/g, ''));
                    const fechaFromDate = dayjs(data.fromDateWeekly).toDate();
                    const fechaToDate = dayjs(data.toDateWeekly).toDate();
                    const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
                    const arrayDays = eachDayOfInterval({
                        start: fechaFromDate,
                        end: fechaToDate,
                    })
                    const dates = arrayDays.filter((day) => newSelectedDays.includes(day.getDay()))
                    const dayLetter = daysOfWeek
                        .filter(day => day.value == data.dayOfWeek)
                        .map(day => day.label);
                    newChilds = [
                        t('schedule.assigned.weeklyScheduling'),
                        t('schedule.assigned.eachSchedulingAvailableDuring', { count: dates.length, dayAvailable: dates.length, days: days }),
                        t('schedule.assigned.generatedEveryFromEdit', { day: dayLetter, startDate: fechaFrom, endDate: fechaTo })
                    ];
                }

                if (data.frequency == FrequencyEnum.CYCLIC) {
                    const fechaFrom = dayjs(data.fromDateCycli).format(Constants.dayjsFormatDate);
                    const fechaTo = dayjs(data.toDateCycli).format(Constants.dayjsFormatDate);
                    const days = formatSelectedDays(selectedDays);
                    const dayNumber = Number(data.duration.replace(/\D/g, ''));
                    const fechaFromDate = dayjs(data.fromDateCycli).toDate();
                    const fechaToDate = dayjs(data.toDateCycli).toDate();
                    const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
                    const arrayDays = eachDayOfInterval({
                        start: fechaFromDate,
                        end: fechaToDate,
                    })
                    const dates = arrayDays.filter((day) => newSelectedDays.includes(day.getDay()))
                    newChilds = [
                        t('schedule.assigned.cyclicalScheduling'),
                        t('schedule.assigned.eachSchedulingAvailableDuring', { count: dates.length, dayAvailable: dates.length, days: days }),
                        t('schedule.assigned.generatedConsecutivelyEdit', { startDate: fechaFrom, endDate: fechaTo })
                    ];
                }
            }
        }
        //childrenRef.current = !!data.openQuestionnaire ? ['', ...newChilds] : newChilds;
        //setChildren(newChilds)
        setModal(prev => ({
            ...prev,
            open: true,
            confirm: () => {
                handleConfirm()
                //closeModal()
            },
            isLoading: true,
            title: t('schedule.modal.confirmation'),
            description: undefined,
            children: option == ScheduleEnumType.RECURRENT ?
                <Box sx={styles.containerChild}>
                    <Typography className="title_text" /* variant='text_grey' */ fontSize={14}>{description}</Typography>
                </Box>
                :
                <Box sx={styles.containerChild}>
                    <Typography className="title_text" /* variant='text_grey' */ fontSize={14}>{description}</Typography>
                    <Box >

                        {newChilds.map((child, index) => (
                            <Box sx={{ display: 'flex' }}>
                                <Box sx={styles.containerCircle}>
                                    <Box sx={styles.circle} />
                                </Box>

                                <Typography sx={styles.textList} fontSize={14}>
                                    {child}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
        }))

    }

    const onChange: onChange = ({ target }) => {
        const { name, value } = target
        let body = { ...data }
        body = {
            ...data,
            [name]: value,
        }
        /* if (name == 'openQuestionnaire' && !value) {
            body.from = dayjs().tz(mimTimeZone.code)
            body.to = null
        } */


        if (name === 'frequency') {
            body = { ...body, every: null }
            setHasInitialized(false);
            setErrors(prev => ({
                ...prev,
                days: ''
            }))
        }

        if (name === 'dayOfWeek') {
            //const day = dayjs(fromDateDaily).day();
            setStartDate(value)
        }

        if (name === 'duration') {
            const soloNumeros = value?.replace(/\D/g, "");
            let errorMessage = '';
            if (soloNumeros < 1 && !!value) {
                errorMessage = t('general.validations.minimusOneDayToDuration');
            }
            setErrors(prev => ({
                ...prev,
                duration: errorMessage
            }))
        }
        if (['from', 'to'].includes(name)) {
            const from = name == 'from' ? value : data.from
            const to = name == 'to' ? value : data.to
            const frequency = data.frequency

            if (frequency == FrequencyEnum.DAYLI && option == ScheduleEnumType.RECURRENT) {
                if (Boolean(to)) {
                    let errorMessage = ''
                    if (dayjs(to).isBefore(dayjs(from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
                    //if (dayjs(to).isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)).add(5, 'minute'))) { errorMessage = t('general.validations.minimusCurrentDay') }
                    if (dayjs(to).isAfter(dayjs(from).add(24, 'hour'))) { errorMessage = t('general.validations.maximum24Hours'); }
                    setErrors(prev => ({
                        ...prev,
                        to: errorMessage
                    }))
                }
            } else {
                if (Boolean(to)) {
                    let errorMessage = ''
                    if (dayjs(to).isBefore(dayjs(from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
                    //if (dayjs(to).isBefore(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value ?? Constants.defaultTimeZoneObject.value)).add(5, 'minute'))) { errorMessage = t('general.validations.minimusCurrentDay') }
                    setErrors(prev => ({
                        ...prev,
                        to: errorMessage
                    }))
                }
            }


        }

        if (['startDateDaily', 'endDateDaily'].includes(name)) {
            const startDateDaily = name == 'startDateDaily' ? value : data.startDateDaily
            const endDateDaily = name == 'endDateDaily' ? value : data.endDateDaily

            if (Boolean(endDateDaily)) {
                let errorMessage = ''
                const start = dayjs(startDateDaily);
                const end = dayjs(endDateDaily);
                const diffInMinutes = end.diff(start, 'minute');
                if (diffInMinutes <= 5) { errorMessage = t('general.validations.minimus5minute') }
                setErrors(prev => ({
                    ...prev,
                    endDateDaily: errorMessage
                }))
            }
        }

        if (['fromDateDaily', 'toDateDaily'].includes(name)) {
            const fromDateDaily = name == 'fromDateDaily' ? value : data.fromDateDaily
            const toDateDaily = name == 'toDateDaily' ? value : data.toDateDaily

            if (Boolean(fromDateDaily)) {
                const day = dayjs(fromDateDaily).day();
                setStartDate(day == 0 ? DaysWeek.SUNDAY : day)
            }

            if (Boolean(toDateDaily)) {
                let errorMessage = ''
                const start = dayjs(fromDateDaily);
                const end = dayjs(toDateDaily);
                const diffInDays = end.diff(start, 'day');
                if (diffInDays < 1) { errorMessage = t('general.validations.minimus1Day') }
                setErrors(prev => ({
                    ...prev,
                    toDateDaily: errorMessage
                }))
            }
        }

        if (['fromDateWeekly', 'toDateWeekly'].includes(name)) {
            const fromDateWeekly = name == 'fromDateWeekly' ? value : data.fromDateWeekly
            const toDateWeekly = name == 'toDateWeekly' ? value : data.toDateWeekly
            /* if (Boolean(fromDateWeekly)) {
                const day = dayjs(fromDateWeekly).day();
                setStartDate(day == 0 ? DaysWeek.SUNDAY : day)
            } */
            if (Boolean(toDateWeekly)) {
                let errorMessage = ''
                const start = dayjs(fromDateWeekly);
                const end = dayjs(toDateWeekly);
                const diffInDays = end.diff(start, 'day');
                if (diffInDays < 7) { errorMessage = t('general.validations.minimus7Day') }
                setErrors(prev => ({
                    ...prev,
                    toDateWeekly: errorMessage
                }))
            }
        }

        if (['fromDateCycli', 'toDateCycli'].includes(name)) {
            const fromDateCycli = name == 'fromDateCycli' ? value : data.fromDateCycli
            const toDateCycli = name == 'toDateCycli' ? value : data.toDateCycli

            if (Boolean(fromDateCycli)) {
                const day = dayjs(fromDateCycli).day();
                setStartDate(day == 0 ? DaysWeek.SUNDAY : day)
            }

            if (Boolean(toDateCycli)) {
                let errorMessage = ''
                const start = dayjs(fromDateCycli);
                const end = dayjs(toDateCycli);
                const diffInDays = end.diff(start, 'day');
                if (diffInDays < 1) { errorMessage = t('general.validations.minimus1Day') }
                setErrors(prev => ({
                    ...prev,
                    toDateCycli: errorMessage
                }))
            }
        }

        if (['fromDateDaily', 'toDateDaily', 'days'].includes(name)) {
            const fromDateCycli = name == 'fromDateDaily' ? value : data.fromDateDaily
            const toDateCycli = name == 'toDateDaily' ? value : data.toDateDaily
            const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
            let errorMessage = ''
            let flag: boolean = true;
            if (Boolean(fromDateCycli) && Boolean(toDateCycli)) {
                let current = dayjs(fromDateCycli)
                const end = dayjs(toDateCycli)

                while (current.isSame(end) || current.isBefore(end)) {
                    const dayOfWeek = current.day()
                    if (newSelectedDays.includes(dayOfWeek)) {
                        flag = false;
                    }
                    current = current.add(1, 'day')
                }

                if (flag) { errorMessage = t('general.validations.daysArentValid') }
                setErrors(prev => ({
                    ...prev,
                    days: errorMessage
                }))
            }
        }

        if (['fromDateCycli', 'toDateCycli', 'days', 'duration'].includes(name)) {
            const fromDateCycli = name == 'fromDateCycli' ? value : data.fromDateCycli
            const toDateCycli = name == 'toDateCycli' ? value : data.toDateCycli
            const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
            const duration = name == 'duration' ? value.replace(/[a-zA-Z]/g, '') : data.duration?.replace(/[a-zA-Z]/g, '');
            let errorMessage = ''
            let secondErrorMessage = ''
            let flag: boolean = true;
            if (Boolean(fromDateCycli) && Boolean(toDateCycli)) {
                let current = dayjs(fromDateCycli)
                const end = dayjs(toDateCycli)

                while (current.isSame(end) || current.isBefore(end)) {
                    const dayOfWeek = current.day()
                    if (newSelectedDays.includes(dayOfWeek)) {
                        flag = false;
                    }
                    current = current.add(1, 'day')
                }

                if (flag) { errorMessage = t('general.validations.daysArentValid') }

                const startToValidate = dayjs(fromDateCycli).toDate();
                const endToValidate = dayjs(toDateCycli).toDate();

                const arrayDays = eachDayOfInterval({
                    start: startToValidate,
                    end: endToValidate,
                })
                const dates = arrayDays.filter((day) => newSelectedDays.includes(day.getDay()))
                if (duration > dates.length) {
                    secondErrorMessage = t('general.validations.isUnderTheDatesRange')
                }

                setErrors(prev => ({
                    ...prev,
                    days: errorMessage,
                    duration: secondErrorMessage
                }))
            }
        }

        if (['fromDateWeekly', 'toDateWeekly', 'duration', 'days'].includes(name)) {
            const fromDateCycli = name == 'fromDateWeekly' ? value : data.fromDateWeekly
            const toDateCycli = name == 'toDateWeekly' ? value : data.toDateWeekly
            const newSelectedDays = selectedDays.map(item => item == 7 ? 0 : item)
            const duration = name == 'duration' ? value.replace(/[a-zA-Z]/g, '') : data.duration?.replace(/[a-zA-Z]/g, '');
            let secondErrorMessage = ''
            if (Boolean(fromDateCycli) && Boolean(toDateCycli)) {
                const startToValidate = dayjs(fromDateCycli).toDate();
                const endToValidate = dayjs(toDateCycli).toDate();

                const arrayDays = eachDayOfInterval({
                    start: startToValidate,
                    end: endToValidate,
                })
                const dates = arrayDays.filter((day) => newSelectedDays.includes(day.getDay()))
                if (duration > dates.length) {
                    secondErrorMessage = t('general.validations.isUnderTheDatesRange')
                }

                setErrors(prev => ({
                    ...prev,
                    duration: secondErrorMessage
                }))
            }


        }

        setData(prev => ({ ...prev, ...body }))
    }

    const loadData = async () => {
        //aca va la respuesta
        setLoadingLocal(true)
        const response = await userScheduleServiceFetch.getDetail({ id: String(id) })
        setLoadingLocal(false)
        setSelected({ questionnaire: [response.questionnaireMain.id], users: [response.userAssignId] })
        setCanChangeStore(false)
        formatresponseSchedule({ mimTimeZone, option, setErrors, t, response, setData, setSelectedDays, setStartDate })
    }

    const [steps, setSteps] = useState(0)

    const [list, setList] = useState<
        Record<string, Record<string, string | number | undefined | null>[]>
    >({})
    const [listItems, setListItems] = useState<Record<string, Item[]>>({})

    const columns = {
        column1: [
            {
                id: 'fullname',
                label: t('useScheduled.detail.tables.fullname'),
                sortable: true,
                minWidth: 120,
            },
            {
                id: 'curp',
                label: t('useScheduled.detail.tables.curp'),
                sortable: true,
                minWidth: 120,
            },
            {
                id: 'userType',
                label: t('useScheduled.detail.tables.userType'),
                sortable: true,
                minWidth: 120,
            },
            {
                id: 'email',
                label: t('useScheduled.detail.tables.email'),
                sortable: true,
                minWidth: 120,
            },
            {
                id: 'phone',
                label: t('useScheduled.detail.tables.phone'),
                sortable: true,
                minWidth: 120,
            },
        ],
        column2: [
            {
                id: 'questionnaireName',
                label: t('useScheduled.detail.tables.questionnaireName'),
                sortable: true,
                minWidth: 120,
            },
            {
                id: 'askAmount',
                label: t('useScheduled.detail.tables.askAmount'),
                sortable: true,
                minWidth: 120,
            },
            {
                id: 'actionPlan',
                label: t('useScheduled.detail.tables.actionPlan'),
                sortable: true,
                minWidth: 120,
            },
            {
                id: 'appAmount',
                label: t('useScheduled.detail.tables.appAmount'),
                sortable: true,
                minWidth: 120,
            },
        ],
    }

    const state = getLocalStorage()

    const getUserType = useCallback(async () => {
        const { items } = await getUserTypes()

        setListItems((prev) => ({
            ...prev,
            userTypes: items,
        }))
    }, [])

    const normalizeHex = (hex?: string | null) => {
        if (!hex) return undefined
        const clean = `${hex}`.trim().replace("#", "")
        if (!clean) return undefined
        return `#${clean}`
    }

    const getUserUnity = async () => {
        const response = await userServiceFetch.listOfStoresByUser({ id: data.user })

        setInputUnity(prev => ({
            ...prev,
            store: {
                ...prev.store,
                items: response.map((store: any) => ({
                    label: `${store.keyCode} - ${store.name}`,
                    value: Number(store.id),
                    id: String(store.id),
                    storeTimeZone: store.storeTimeZone,
                    storeStatusName: store?.storeStatus?.name ?? null,
                    storeStatusColor: normalizeHex(store?.storeStatus?.color) ?? null,
                })),
            },
        }))
    }

    const getAllUsers = useCallback(async () => {
        setIsLoading(true)
        const { all } = await getUsers({ skip: [Roles.ADMIN] })
        let items: Item[] = [

        ]
        let body: {
            id: number,
            fullname: string,
            curp: string,
            userType: string,
            userTypeId: number,
            email: string,
            phone: string,
        }[] = []

        const exist = all?.some(user => user.id === state.id)
        if (Roles.ADMIN !== state.role && !exist) {
            body.push({
                id: state.id,
                fullname: state.fullName,
                curp: state.curp ?? "",
                userType: state.userType?.name,
                userTypeId: state.userType?.id,
                email: state.email,
                phone: state.phone,
            })
        }
        body = [
            ...body,
            ...all?.map((item) => {
                items.push({
                    label: `${item.firstName ? `${item.firstName} ` : ''}${item.lastName}`,
                    value: item.id,
                })
                return {
                    id: item.id,
                    fullname: `${item.firstName ? `${item.firstName} ` : ''}${item.lastName
                        }`,
                    curp: item.curp,
                    userType: item.userType,
                    userTypeId: item.userTypeId,
                    email: item.email,
                    phone: item.phone,
                }
            }) || []
        ]

        setIsLoading(false)

        setListItems((prev) => ({
            ...prev,
            users: items,
        }))
        setList((prev) => ({
            ...prev,
            users: body ?? [],
        }))
    }, [])

    const getAllQuestionnaires = useCallback(async () => {
        setIsLoading(true)

        const all = await questionnaire.getAllQuestionariesOld({ type: false })
        let body: any[] = []
        let items: Item[] = []

        if (!all.errors) {
            body = all.map((item) => {
                let action_plan = item.actionPlanByItem
                let actionType = item.actionPlanByItem === 'Por Item' ? '0' : '1'

                if (typeof item.actionPlanByItem === 'boolean') {
                    action_plan = item.actionPlanByItem ? 'Por Item' : 'Por Cuestionario'
                    actionType = !!item.actionPlanByItem ? '0' : '1'
                }

                items.push({
                    label: item.name,
                    value: item.id,
                })

                return {
                    id: item.id,
                    questionnaireName: item.name,
                    askAmount: item.countQuestions,
                    actionPlan: action_plan,
                    actionType,
                    appAmount: item.countQuestionnaireVisit,
                }
            })
        }
        setIsLoading(false)
        setListItems((prev) => ({
            ...prev,
            questionnaires: items,
        }))
        setList((prev) => ({
            ...prev,
            questionnaires: body,
        }))
    }, [])

    const { handleFilter, handleCheanFilter, row, filterData, counter, } = useFilter({ steps, lists: list, })


    const inputUser: Record<string, InputModel> = (
        {
            ...usersInput,
            userType: {
                ...usersInput.userType,
                items: listItems.userTypes ?? [],
            },
        }
    )

    const inputQuestionarie: Record<string, InputModel> = (
        {
            ...questionnairesInput,
        }
    )

    const [inputUnity, setInputUnity] = useState<{ [x: string]: InputModel }>({
        store: {
            label: 'general.tags.idStore',
            translate: true,
            name: 'store',
            type: 'select-search',
            value: null,
            items: [],
            size: {
                xl: 12,
                lg: 12,
                md: 12,
                sm: 12,
            },
        },
    })

    const handleConfirm = async () => {
        setLoadSubmit(true)
        const body = formatDataToEndoint({ data, selectedDays, selected, option })
        let response;
        if (option == ScheduleEnumType.UNIQUE) {
            response = await userScheduleServiceFetch.updateUserSchedule({ body: body[0], id: String(id) })
        }

        if (option == ScheduleEnumType.RECURRENT) {
            response = await userScheduleServiceFetch.updateUserScheduleRecurrent({ body: body[0], id: String(id) });
        }

        if (option == ScheduleEnumType.SERIE) {
            response = await userScheduleServiceFetch.updateUserScheduleSerie({ body: body[0], id: Number(data.serieId) });
        }

        //response= await ScheduleService(httpFetch).updateSchedule(body[0], Number(id));
        if (response?.errors) {
            if (response?.errors[0].code !== '02') {
                setOpenSnackbar({ ...openSnackbar, open: true, message: handleAllErrors(response.errors[0].code as RequestErrors, t), type: Types.ERROR })
            } else {
                setOpenSnackbar({ ...openSnackbar, open: true, message: handleAllErrors(response.errors[0].data?.errors[0].code as RequestErrors, t), type: Types.ERROR })
            }
        } else {
            setOpenSnackbar({ ...openSnackbar, open: true, message: option !== ScheduleEnumType.SERIE ? t('schedule.modal.editSuccessSchedule') : t('schedule.modal.editSuccessSerie'), type: Types.SUCCESS })
            setTimeout(() => {
                navigate('/dashboard/schedule-user/');
            }, 3000);
        }
        setLoadSubmit(false)
        closeModal()

    }

    useEffect(() => {

        if (hasInitialized) return;

        setSelectedDays([DaysWeek.MONDAY, DaysWeek.TUESDAY, DaysWeek.WEDNESDAY, DaysWeek.THURSDAY, DaysWeek.FRIDAY, DaysWeek.SATURDAY, DaysWeek.SUNDAY])
        setData(prev => ({
            ...prev, from: null, to: null, startDateDaily: null, endDateDaily: null, fromDateDaily: null,
            toDateDaily: null, fromDateCycli: null, toDateCycli: null, startDate: null, duration: null,
            endDate: null, dayOfWeek: null, fromDateWeekly: null, toDateWeekly: null, durationCycli: null
        }))
        setStartDate(undefined)
    }, [data.frequency])

    useEffect(() => {
        loadData()

        getAllUsers()
        getAllQuestionnaires()
        getUserType()
    }, [id])

    useEffect(() => {
        if (!!data.user) {
            getUserUnity()
            if (canChangeStore) {
                setData(prev => ({
                    ...prev, store: null
                }))
            } else {
                setCanChangeStore(true)
            }

        }
    }, [data.user])


    const getSection = () => {
        let caseSection = <></>
        switch (section) {
            case SectionType.Unity:
                caseSection =
                    <HeaderTable
                        counter={counter ?? 0}
                        isLoading={isLoading}
                        onClickBack={() => { setSection(SectionType.IndexSerie) }}
                        refTable={refTable}
                        column={columns.column1}
                        row={row}
                        onClickTable={(e) => {
                            setSelected({
                                ...selected,
                                users: e.checks,
                            })
                        }}
                        inputFilter={inputUser}
                        filterData={filterData[0]}
                        handleCheanFilter={handleCheanFilter}
                        handleFilter={handleFilter}
                        titleTable={t('useScheduled.userSelect')}
                        defraultChecks={selected.users}
                    />
                break
            case SectionType.Questionarie:
                caseSection =
                    <HeaderTable
                        counter={counter ?? 0}
                        isLoading={isLoading}
                        onClickBack={() => { setSection(SectionType.IndexSerie) }}
                        refTable={refTable}
                        column={columns.column2}
                        row={row}
                        onClickTable={(e) => {
                            setSelected({
                                ...selected,
                                questionnaire: e.checks,
                            })
                        }}
                        inputFilter={inputQuestionarie}
                        filterData={filterData[1]}
                        handleCheanFilter={handleCheanFilter}
                        handleFilter={handleFilter}
                        titleTable={t('schedule.filter.filterQuestionnaire.titleOnlyOne')}
                        defraultChecks={selected.questionnaire}
                    />
                break
            case SectionType.IndexSerie:
                caseSection = <ConfigCalendarSerie
                    data={data}
                    errors={errors}
                    assignedChildren={assignedChildren}
                    setSteps={setSteps}
                    onChange={onChange}
                    selectedText={{ questionnaire: selectedText.questionnaire, stores: selectedText.users }}
                    setModal={setModal}
                    disabled={disabled}
                    scheduleType={option}
                    setSection={setSection}
                    mimTimeZone={mimTimeZone}
                    refRange={refRange}
                    selectedDays={selectedDays}
                    setData={setData}
                    setSelectedDays={setSelectedDays}
                    setStartDate={setStartDate}
                    startDate={startDate}
                    maxToDay={data.maxToDay}
                    secondText={t('useScheduled.detail.buttons.user')}
                    secondButonTitle={t('useScheduled.detail.buttons.selectOtherUser')}
                    firstInput={inputUnity}
                    titelForm={t('useScheduled.referenceStore')}
                    stringToNavigate='/dashboard/schedule-user/'
                />
                break
            default:
                caseSection = <></>
        }

        return caseSection
    }

    const lookForInvalidateFields = () => {
        if (option == ScheduleEnumType.UNIQUE || option == ScheduleEnumType.SERIE) {
            if (data?.frequency == FrequencyEnum.UNIQUE) {
                return !(
                    Boolean(data?.from) && Boolean(data?.to) && Boolean(data?.frequency) &&
                    dayjs(data?.to).isAfter(dayjs(data.from).add(5, 'minute')) //&&
                    //dayjs(data?.to).isAfter(dayjs(toUnitTimeZone(new Date(), mimTimeZone.value,)).add(5, 'minute'))
                )
            }
            if (data?.frequency == FrequencyEnum.DAYLI) {
                return !(
                    selectedDays.length !== 0 &&
                    Boolean(data?.startDateDaily) && Boolean(data?.endDateDaily) && Boolean(data?.fromDateDaily) && Boolean(data?.toDateDaily) &&
                    dayjs(data?.endDateDaily).isAfter(dayjs(data.startDateDaily).add(4, 'minute')) &&
                    dayjs(data?.toDateDaily).isAfter(dayjs(data.fromDateDaily))
                )
            }
            if (data?.frequency == FrequencyEnum.WEEKLY) {
                return !(
                    selectedDays.length !== 0 &&
                    Boolean(data?.startDate) && Boolean(data?.duration) && Boolean(data?.dayOfWeek) && Boolean(data?.endDate) && Boolean(data?.fromDateWeekly) && Boolean(data?.toDateWeekly) &&
                    dayjs(data?.toDateWeekly).isAfter(dayjs(data.fromDateWeekly).add(6, 'days')) &&
                    selectedDays.includes(data?.dayOfWeek)
                )
            }

            if (data?.frequency == FrequencyEnum.CYCLIC) {
                return !(
                    selectedDays.length !== 0 &&
                    Boolean(data?.startDate) && Boolean(data?.duration) && Boolean(data?.endDate) && Boolean(data?.fromDateCycli) && Boolean(data?.toDateCycli) &&
                    dayjs(data?.toDateCycli).isAfter(dayjs(data.fromDateCycli))
                    //validar que sea una semana despues
                )
                //&&
                //validar que sea una semana despues
            }

        }

        if (option == ScheduleEnumType.RECURRENT) {
            if (data?.frequency == FrequencyEnum.DAYLI) {
                return !(
                    selectedDays.length !== 0 &&
                    Boolean(data?.from) && Boolean(data?.to) && /* Boolean(data?.toDateDaily) && */
                    dayjs(data?.to).isAfter(dayjs(data.from).add(4, 'minute')) /* &&
                    dayjs(data?.toDateDaily).isAfter(dayjs(data.fromDateDaily)) */
                )
            }
            if (data?.frequency == FrequencyEnum.WEEKLY) {
                return !(
                    selectedDays.length !== 0 &&
                    Boolean(data?.from) && Boolean(data?.to) /* &&  *//* Boolean(data?.dayOfWeek) && Boolean(data?.endDate) && Boolean(data?.fromDateWeekly) && Boolean(data?.toDateWeekly) && */
                    /* dayjs(data?.to).isAfter(dayjs(data.from).add(6, 'days'))  *//* &&
                    selectedDays.includes(data?.dayOfWeek) */
                )
            }

            if (data?.frequency == FrequencyEnum.CYCLIC) {
                return !(
                    selectedDays.length !== 0 &&
                    Boolean(data?.from) && Boolean(data?.to) /* && Boolean(data?.endDate) && Boolean(data?.fromDateCycli) && Boolean(data?.toDateCycli) &&
                    dayjs(data?.toDateCycli).isAfter(dayjs(data.fromDateCycli)) */
                    //validar que sea una semana despues
                )
                //&&
                //validar que sea una semana despues
            }
        }

        return false
        //Aca van las validaciones del disable

    }

    const disabled = () => {
        if (!selected.questionnaire || !selected.users || !data.user || !selectedText.questionnaire) return true
        if (data?.openQuestionnaire) return false
        if (Object.values(errors).some((item: any) => !!item)) return true
        return lookForInvalidateFields()
    }


    useEffect(() => {
        const clickedRowStore = list.users?.find(row => row.id === selected.users[0]);
        const clickedTimeZone = listItems.users?.find(row => row.value === selected.users[0]);
        const clickedRowQuestionarie = listItems.questionnaires?.find(row => row.value === selected.questionnaire[0]);
        setSelectedText({ questionnaire: String(clickedRowQuestionarie?.label), users: String(clickedRowStore?.fullname) })
        const theBiggest = !clickedTimeZone ? Constants.defaultTimeZoneObject : clickedTimeZone?.storeTimeZone ?? Constants.defaultTimeZoneObject;
        setmimTimeZone(theBiggest)
        setData(prev => ({
            ...prev, user: clickedRowStore?.id
        }))
    }, [selected, listItems, list])


    return (
        <> {(loadingLocal || isLoading) ?
            <Loader />
            :
            <>
                <Box sx={styles.body}>{getSection()}</Box>
                <SimpleModal
                    open={!!modal.open}
                    next={modal?.confirm}
                    back={closeModal}
                    close={closeModal}
                    description={modal.description}
                    buttonText={t('general.confirm')}
                    cancelText={t('general.cancel')}
                    title={modal.title}
                    sx={{ width: '470px' }}
                    children={modal.children}
                    loadingButton={modal.isLoading}
                    isLoading={loadSubmit}
                />
                <SnackSimple close={handleCloseSnackbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} />
            </>
        }

        </>

    )
}

export { EditSerieUser }
